import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _classPrivateFieldInitSpec from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assertReturn, compactAddLength, compactStripLength, compactToU8a, isHex, isU8a } from '@polkadot/util';
import { Raw } from "../native/Raw.js";
import { typeToConstructor } from "../utils/index.js";
import { Bytes } from "./Bytes.js";

function decodeRaw(registry, typeName, value) {
  var Type = typeToConstructor(registry, typeName);

  if (isU8a(value) || isHex(value)) {
    try {
      var _ref = isHex(value) || value instanceof Raw ? [0, value] : compactStripLength(value),
          _ref2 = _slicedToArray(_ref, 2),
          u8a = _ref2[1];

      return [Type, new Type(registry, u8a), value];
    } catch (_unused) {
      return [Type, null, value];
    }
  }

  var instance = new Type(registry, value);
  return [Type, instance, compactAddLength(instance.toU8a())];
}

var _Type = /*#__PURE__*/new WeakMap();

var _decoded = /*#__PURE__*/new WeakMap();

var _opaqueName = /*#__PURE__*/new WeakMap();

export var WrapperKeepOpaque = /*#__PURE__*/function (_Bytes) {
  _inherits(WrapperKeepOpaque, _Bytes);

  var _super = _createSuper(WrapperKeepOpaque);

  function WrapperKeepOpaque(registry, typeName, value) {
    var _this;

    var _ref3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref3$opaqueName = _ref3.opaqueName,
        opaqueName = _ref3$opaqueName === void 0 ? 'WrapperKeepOpaque' : _ref3$opaqueName;

    _classCallCheck(this, WrapperKeepOpaque);

    var _decodeRaw = decodeRaw(registry, typeName, value),
        _decodeRaw2 = _slicedToArray(_decodeRaw, 3),
        Type = _decodeRaw2[0],
        decoded = _decodeRaw2[1],
        u8a = _decodeRaw2[2];

    _this = _super.call(this, registry, u8a);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _Type, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _decoded, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _opaqueName, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(_assertThisInitialized(_this), _Type, Type);

    _classPrivateFieldSet(_assertThisInitialized(_this), _decoded, decoded);

    _classPrivateFieldSet(_assertThisInitialized(_this), _opaqueName, opaqueName);

    return _this;
  }

  _createClass(WrapperKeepOpaque, [{
    key: "isDecoded",
    get:
    /**
     * @description Checks if the wrapper is decodable
     */
    function get() {
      return !!_classPrivateFieldGet(this, _decoded);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */

  }, {
    key: "inspect",
    value: function inspect() {
      return _classPrivateFieldGet(this, _decoded) ? {
        inner: [_classPrivateFieldGet(this, _decoded).inspect()],
        outer: [compactToU8a(this.length)]
      } : {
        outer: [compactToU8a(this.length), this.toU8a(true)]
      };
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman(isExtended) {
      return _classPrivateFieldGet(this, _decoded) ? _classPrivateFieldGet(this, _decoded).toHuman(isExtended) : _get(_getPrototypeOf(WrapperKeepOpaque.prototype), "toHuman", this).call(this);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return "".concat(_classPrivateFieldGet(this, _opaqueName), "<").concat(this.registry.getClassName(_classPrivateFieldGet(this, _Type)) || (_classPrivateFieldGet(this, _decoded) ? _classPrivateFieldGet(this, _decoded).toRawType() : new (_classPrivateFieldGet(this, _Type))(this.registry).toRawType()), ">");
    }
    /**
     * @description Converts the Object to to a string (either decoded or bytes)
     */

  }, {
    key: "toString",
    value: function toString() {
      return _classPrivateFieldGet(this, _decoded) ? _classPrivateFieldGet(this, _decoded).toString() : _get(_getPrototypeOf(WrapperKeepOpaque.prototype), "toString", this).call(this);
    }
    /**
     * @description Returns the decoded that the WrapperKeepOpaque represents (if available), throws if non-decodable
     */

  }, {
    key: "unwrap",
    value: function unwrap() {
      var _this2 = this;

      return assertReturn(_classPrivateFieldGet(this, _decoded), function () {
        return "".concat(_classPrivateFieldGet(_this2, _opaqueName), ": unwrapping an undecodable value");
      });
    }
  }], [{
    key: "with",
    value: function _with(Type) {
      return /*#__PURE__*/function (_WrapperKeepOpaque) {
        _inherits(_class, _WrapperKeepOpaque);

        var _super2 = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super2.call(this, registry, Type, value);
        }

        return _createClass(_class);
      }(WrapperKeepOpaque);
    }
  }]);

  return WrapperKeepOpaque;
}(Bytes);